<div class="mydrp" [ngStyle]="{ width: opts.width, border: opts.inline ? 'none' : null }">
	@if (!opts.inline) {
		<div class="selectiongroup">
			<input
				autocomplete="off"
				autocorrect="off"
				class="selection"
				placeholder="{{ placeholder }}"
				spellcheck="false"
				type="text"
				[attr.aria-label]="opts.ariaLabelInputField"
				[attr.maxlength]="dateRangeFormat.length"
				[disabled]="opts.componentDisabled"
				[ngClass]="{
					invaliddaterange: invalidDateRange && opts.indicateInvalidDateRange,
					inputnoteditable: opts.openSelectorOnInputClick && !opts.editableDateRangeField,
					selectiondisabled: opts.componentDisabled,
				}"
				[ngModel]="selectionDayTxt"
				[ngStyle]="{ height: opts.height, 'font-size': opts.selectionTxtFontSize }"
				[readonly]="!opts.editableDateRangeField"
				[value]="selectionDayTxt"
				(blur)="opts.editableDateRangeField && onBlurInput($event)"
				(click)="opts.openSelectorOnInputClick && !opts.editableDateRangeField && openBtnClicked()"
				(focus)="opts.editableDateRangeField && onFocusInput($event)"
				(keyup)="onCloseSelector($event)"
				(ngModelChange)="onUserDateRangeInput($event)"
			/>
			<span class="selbtngroup" [style.height]="opts.height">
				@if (selectionDayTxt.length > 0 && opts.showClearDateRangeBtn) {
					<button
						class="btnclear"
						type="button"
						[attr.aria-label]="opts.ariaLabelClearDateRange"
						[disabled]="opts.componentDisabled"
						[ngClass]="{ btnclearenabled: !opts.componentDisabled, btncleardisabled: opts.componentDisabled }"
						(click)="removeBtnClicked(); $event.stopPropagation()"
					>
						<span class="mydrpicon icon-mydrpremove"></span>
					</button>
				}
				<button
					class="btnpicker"
					type="button"
					[attr.aria-label]="opts.ariaLabelOpenCalendar"
					[disabled]="opts.componentDisabled"
					[ngClass]="{ btnpickerenabled: !opts.componentDisabled, btnpickerdisabled: opts.componentDisabled }"
					(click)="openBtnClicked()"
				>
					<span class="mydrpicon icon-mydrpcalendar"></span>
				</button>
			</span>
		</div>
	}
	@if (showSelector || opts.inline) {
		<div
			#selectorEl
			class="selector"
			tabindex="0"
			[mydrpfocus]="opts.inline ? '0' : '1'"
			[ngClass]="{
				'ic-inline': opts.inline,
				alignselectorright: opts.alignSelectorRight,
				selectorarrow: opts.showSelectorArrow && !opts.inline,
				selectorarrowleft: opts.showSelectorArrow && !opts.alignSelectorRight && !opts.inline,
				selectorarrowright: opts.showSelectorArrow && opts.alignSelectorRight && !opts.inline,
			}"
			[ngStyle]="{ width: opts.selectorWidth, height: opts.selectorHeight }"
			(keyup)="onCloseSelector($event)"
		>
			@if (opts.showSelectDateText) {
				<div class="titlearea">
					<div class="titleareatxt">{{ titleAreaText !== "" ? titleAreaText : opts.selectBeginDateTxt }}</div>
				</div>
			}
			<table class="header">
				<tr>
					<td>
						<div style="float: left">
							<div class="headerbtncell">
								<button
									class="headerbtn mydrpicon icon-mydrpleft"
									type="button"
									[attr.aria-label]="opts.ariaLabelPrevMonth"
									[disabled]="prevMonthDisabled"
									[ngClass]="{ headerbtnenabled: !prevMonthDisabled, headerbtndisabled: prevMonthDisabled }"
									(click)="onPrevMonth()"
								></button>
							</div>
							<div class="headermonthtxt">
								<button
									class="headerlabelbtn"
									tabindex="{{ opts.monthSelector ? '0' : '-1' }}"
									type="button"
									[ngClass]="{ monthlabel: opts.monthSelector }"
									(click)="opts.monthSelector && onSelectMonthClicked($event)"
								>
									{{ visibleMonth.monthTxt }}
								</button>
							</div>
							<div class="headerbtncell">
								<button
									class="headerbtn mydrpicon icon-mydrpright"
									type="button"
									[attr.aria-label]="opts.ariaLabelNextMonth"
									[disabled]="nextMonthDisabled"
									[ngClass]="{ headerbtnenabled: !nextMonthDisabled, headerbtndisabled: nextMonthDisabled }"
									(click)="onNextMonth()"
								></button>
							</div>
						</div>
					</td>
					<td>
						@if (opts.showClearBtn) {
							<button
								class="headerclearbtn"
								type="button"
								[disabled]="beginDate.year === 0 && endDate.year === 0"
								[ngClass]="{
									clearbtndisabled: beginDate.year === 0 && endDate.year === 0,
									headerclearbtnenabled: beginDate.year !== 0 || endDate.year !== 0,
								}"
								(click)="clearDateRange()"
							>
								<span class="mydrpicon icon-mydrpremove"></span>
							</button>
						}
						@if (opts.showApplyBtn) {
							<button
								class="headerokbtn"
								type="button"
								[disabled]="endDate.year === 0"
								[ngClass]="{ okbtndisabled: endDate.year === 0, headerokbtnenabled: endDate.year !== 0 }"
								(click)="rangeSelected()"
							>
								<span class="mydrpicon icon-mydrpok"></span>
							</button>
						}
					</td>
					<td>
						<div style="float: right">
							<div class="headerbtncell">
								<button
									class="headerbtn mydrpicon icon-mydrpleft"
									type="button"
									[attr.aria-label]="opts.ariaLabelPrevYear"
									[disabled]="prevYearDisabled"
									[ngClass]="{ headerbtnenabled: !prevYearDisabled, headerbtndisabled: prevYearDisabled }"
									(click)="onPrevYear()"
								></button>
							</div>
							<div class="headeryeartxt">
								<button
									class="headerlabelbtn"
									tabindex="{{ opts.yearSelector ? '0' : '-1' }}"
									type="button"
									[ngClass]="{ yearlabel: opts.yearSelector }"
									(click)="opts.yearSelector && onSelectYearClicked($event)"
								>
									{{ visibleMonth.year }}
								</button>
							</div>
							<div class="headerbtncell">
								<button
									class="headerbtn mydrpicon icon-mydrpright"
									type="button"
									[attr.aria-label]="opts.ariaLabelNextYear"
									[disabled]="nextYearDisabled"
									[ngClass]="{ headerbtnenabled: !nextYearDisabled, headerbtndisabled: nextYearDisabled }"
									(click)="onNextYear()"
								></button>
							</div>
						</div>
					</td>
				</tr>
			</table>
			@if (!selectMonth && !selectYear) {
				<table
					class="caltable"
					[ngStyle]="{ height: opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)' }"
				>
					<thead>
						<tr>
							@if (opts.showWeekNumbers && opts.firstDayOfWeek === "mo") {
								<th class="weekdaytitle weekdaytitleweeknbr">#</th>
							}
							@for (d of weekDays; track $index) {
								<th class="weekdaytitle" scope="col">{{ d }}</th>
							}
						</tr>
					</thead>
					<tbody>
						@for (w of dates; track $index) {
							<tr>
								@if (opts.showWeekNumbers && opts.firstDayOfWeek === "mo") {
									<td class="daycell daycellweeknbr">
										{{ w.weekNbr }}
									</td>
								}
								@for (d of w.week; track $index) {
									<td
										class="daycell"
										tabindex="0"
										[ngClass]="{
											currmonth: d.cmo === currMonthId && !d.disabled,
											range: isInRange(d) || d.range,
											disabled: d.disabled,
										}"
										(click)="!d.disabled && onCellClicked(d); $event.stopPropagation()"
										(keydown)="onCellKeyDown($event, d)"
										(mouseenter)="onCellMouseEnter(d)"
										(mouseleave)="onCellMouseLeave()"
									>
										<div
											class="datevalue"
											[ngClass]="{
												prevmonth: d.cmo === prevMonthId,
												selecteddaybegin:
													beginDate.day === d.dateObj.day
													&& beginDate.month === d.dateObj.month
													&& beginDate.year === d.dateObj.year,
												selecteddayend:
													endDate.day === d.dateObj.day
													&& endDate.month === d.dateObj.month
													&& endDate.year === d.dateObj.year,
												currmonth: d.cmo === currMonthId,
												nextmonth: d.cmo === nextMonthId,
												sunday: d.dayNbr === 0 && opts.sunHighlight,
											}"
										>
											<span
												[ngClass]="{
													markcurrday: d.currDay && opts.markCurrentDay,
													sundayDim:
														opts.sunHighlight
														&& d.dayNbr === 0
														&& (d.cmo === prevMonthId || d.cmo === nextMonthId || d.disabled),
												}"
												>{{ d.dateObj.day }}</span
											>
										</div>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			}
			@if (selectMonth) {
				<table
					class="monthtable"
					[ngStyle]="{ height: opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)' }"
				>
					<tbody>
						@for (mr of months; track $index) {
							<tr>
								@for (m of mr; track m.nbr) {
									<td
										class="monthcell tablesinglemonth"
										tabindex="0"
										[ngClass]="{ selectedmonth: m.selected, disabled: m.disabled }"
										(click)="!m.disabled && onMonthCellClicked(m); $event.stopPropagation()"
										(keydown)="onMonthCellKeyDown($event, m)"
									>
										<div class="monthvalue" [ngClass]="{ markcurrmonth: m.currMonth && opts.markCurrentMonth }">
											{{ m.name }}
										</div>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			}
			@if (selectYear) {
				<table
					class="yeartable"
					[ngStyle]="{ height: opts.showSelectDateText ? 'calc(100% - 54px)' : 'calc(100% - 30px)' }"
				>
					<tbody>
						<tr>
							<td class="yearchangebtncell" colspan="5" (click)="$event.stopPropagation()">
								<button
									class="yearchangebtn mydrpicon icon-mydrpup"
									type="button"
									[disabled]="prevYearsDisabled"
									[ngClass]="{ yearchangebtnenabled: !prevYearsDisabled, yearchangebtndisabled: prevYearsDisabled }"
									(click)="onPrevYears($event, years[0][0].year)"
								></button>
							</td>
						</tr>
						@for (yr of years; track $index) {
							<tr>
								@for (y of yr; track y.year) {
									<td
										class="yearcell tablesingleyear"
										tabindex="0"
										[ngClass]="{ selectedyear: y.selected, disabled: y.disabled }"
										(click)="!y.disabled && onYearCellClicked(y); $event.stopPropagation()"
										(keydown)="onYearCellKeyDown($event, y)"
									>
										<div class="yearvalue" [ngClass]="{ markcurryear: y.currYear && opts.markCurrentYear }">
											{{ y.year }}
										</div>
									</td>
								}
							</tr>
						}
						<tr>
							<td class="yearchangebtncell" colspan="5" (click)="$event.stopPropagation()">
								<button
									class="yearchangebtn mydrpicon icon-mydrpdown"
									type="button"
									[disabled]="nextYearsDisabled"
									[ngClass]="{ yearchangebtnenabled: !nextYearsDisabled, yearchangebtndisabled: nextYearsDisabled }"
									(click)="onNextYears($event, years[0][0].year)"
								></button>
							</td>
						</tr>
					</tbody>
				</table>
			}
		</div>
	}
</div>
